import MeterHttp from "./MeterHttp";
export default class MeterOrderFlowHelp {
  static isMeterOrderAble(project_id,read_month,callback){
    MeterHttp.post("MeterOrderFlow/isMeterOrderAble", {
      project_id:project_id,
      read_month:read_month,
    }, res => {
      callback(res)
    })
  }
  static isMeterOrderFlowPass(project_id,read_month,callback){
    MeterHttp.post("MeterOrderFlow/isMeterOrderFlowPass", {
      project_id:project_id,
      read_month:read_month,
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/common/MeterOrderFlowHelp.js